import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.div`
  ${({ theme, displayState }) => css`
    font-size: 14px;
    font-weight: ${displayState?.bold ? 600 : 400};
    margin-left: 10px;
    color: ${theme?.colour?.secondary};
    margin-left: 10px;
`}
`;

export default Atom({ type: 'label', dataType: 'string', template })